export const TOGGLE_LANGUAGE = 'TOGGLE_LANGUAGE';
export const dispatchToggleLanguage = () => ({
    type: TOGGLE_LANGUAGE,
});
